import { makeStyles, styled } from '@mui/styles';
import CreateIcon from '@mui/icons-material/Create';

export const useStyles = makeStyles(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  (theme: any) => ({
    root: {
      width: '100%',
      paddingTop: theme.spacing(4.5),
      paddingBottom: theme.spacing(3),
      marginBottom: theme.spacing(4),
      height: 'auto',
      justifyContent: 'center',
      alignItems: 'flex-start'
    },
    addButton: {
      marginTop: theme.spacing(-5),
      position: 'absolute',
      display: 'block',
      right: theme.spacing(3)
    },
    headerClass: {
      width: '100%'
    },
    contentWrapper: {
      marginTop: theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        minHeight: '750px'
      }
    },
    tableWithHeaderWrapper: {
      height: '100%',
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    tableWrapper: {
      minHeight: '360px'
    },
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-start'
      }
    }
  })
);

export const IconWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2.2rem',
  height: '2.2rem',
  borderRadius: '50%',
  '&:hover': {
    cursor: 'pointer'
  }
}));

export const PencilIcon = styled(CreateIcon)(() => ({
  color: '#fff'
}));
